export const DEFAULT_DATAGRID_PAGE_SIZE = 5;
export const DEFAULT_COLUMN_SIZE = 150;
export const DEFAULT_RECONNECT_TIME_INTERVAL = 2000;